import { useState, useEffect, useRef } from "react";
import { useProductGlobalSearch } from "../../queries/useProductsQuery";
import { useDebounce } from "../../hooks/useDebounce";
import styles from "./globalsearch.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { getImageUrl } from "../../lib/get-image";
import { HeadingTitle, SubHeadingTitle, Image } from "../shared";
import { CiSearch } from "react-icons/ci";
import { FiCamera } from "react-icons/fi";
import levenshtein from "fast-levenshtein";
import Tesseract from "tesseract.js";
import axios from "axios";
import { CATEGORIES_SLUGS } from "../../constants/products-filters-data";
const GlobalProductsSearch = ({ onClose = () => {}, categories = [] }) => { 
  const navigate = useNavigate();
  const location = useLocation();
 const PRODUCT_API = process.env.REACT_APP_HOME_PAGE_API;
  const [input, setInput] = useState("");
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const normalized = input.trim().toLowerCase();
  const debounced = useDebounce(input);
  const [imageResults, setImageResults] = useState([]); 
const fileInputRef = useRef(null);
const handleImageUpload = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  try {
    const formData = new FormData();

    formData.append("file", file);
    formData.append(
      "apikey",
      process.env.REACT_APP_OCR_SPACE_API_KEY
    );

    formData.append("language", "eng");
    formData.append("OCREngine", "2");
    formData.append("scale", "true");
    formData.append(
      "detectOrientation",
      "true"
    );

    const response = await axios.post(
      "https://api.ocr.space/parse/image",
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    const text =
      response.data?.ParsedResults?.[0]
        ?.ParsedText || "";

    console.log("OCR TEXT:", text);

    const extractedItems = text
      .split("\n")
      .map((line) => line.trim())
      .filter(
        (line) =>
          line.length > 2
      );

    console.log(
      "Extracted Items:",
      extractedItems
    );

    navigate("/shopping-list", {
      state: {
        extractedItems,
      },
    });

    resetSearch();
  } catch (error) {
    console.log(
      "OCR Space Error:",
      error
    );
  }
};
  const shouldSearch = debounced.trim().length >= 2;
  const { data, isPending } = useProductGlobalSearch(
    shouldSearch ? debounced : ""
  ); 

  const products = data?.products || [];
 const suggestions =
  normalized.length === 0
    ? categories
    : categories.filter((c) =>
        c.name.toLowerCase().includes(normalized)
      );
 const showSuggestions = suggestions.length > 0;
  const showProducts = products.length > 0;
  const isSingleProduct = products.length === 1 && !showSuggestions;
  /* 🔹 CLEAR SEARCH COMPLETELY */
  const resetSearch = () => {
    setInput("");
    setOpen(false);
    onClose();
  };
  /* 🔹 CATEGORY NAVIGATION */
 const goCategory = (slug) => {
  resetSearch();
  navigate(`/shop?category=${slug}`);
};
  /* 🔹 PRODUCT NAVIGATION */
  const goProduct = (slug) => {
    resetSearch();
    navigate(`/productdetails/${slug}`);
  };
  /* 🔹 ENTER KEY SUBMIT */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!normalized) return;
    resetSearch();
    if (isSingleProduct) {
      navigate(`/productdetails/${products[0].slug}`);
    } else {
      navigate(`/shop/${normalized.replace(/\s+/g, "-")}`);
    }
  };
  /* 🔹 CLOSE SEARCH ON ROUTE CHANGE */
  useEffect(() => {
    resetSearch();
  }, [location.pathname]);
  /* 🔹 CLOSE ON OUTSIDE CLICK */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  console.log("categories:", categories);


  return (
    <form onSubmit={handleSubmit} className={styles.searchWrapper}>
    <div className={styles.searchBox} ref={wrapperRef}>
  <CiSearch
    className={styles.searchIcon}
    size={22}
  />

  <input
    value={input}
    onFocus={() => setOpen(true)}
    onChange={(e) => {
      setInput(e.target.value);
      setOpen(true);
    }}
    placeholder="Search  anything you need....."
    className={styles.searchInput}
  />

  {/* <button
    type="button"
    className={styles.cameraBtn}
    onClick={() =>
      fileInputRef.current?.click()
    }
  >
    <FiCamera size={20} />
  </button>  */}

  <input
    ref={fileInputRef}
    type="file"
    accept="image/*"
    style={{ display: "none" }}
    onChange={handleImageUpload}
  /> 
  {open && (
  <div className={styles.searchDropdown}>

    {showSuggestions && (
      <>
        <HeadingTitle
          text="Suggestions"
          style={styles.dropdownHeading}
        />

        {suggestions.map((item) => (
          <div
            key={item.slug}
            className={styles.dropdownItem}
            onMouseDown={() =>
              goCategory(item.slug)
            }
          >
            <CiSearch size={18} />
            {item.name}
          </div>
        ))}
      </>
    )}

    {showProducts && (
      <>
        <HeadingTitle
          text="Products"
          style={styles.dropdownHeading}
        />

        {products.map((p) => (
          <div
            key={p.id}
            className={styles.dropdownItem}
            onMouseDown={() =>
              goProduct(p.slug)
            }
          >
            <Image
              src={getImageUrl(
                p.thumb_image
              )}
              alt={p.name}
              className={styles.itemThumbnail}
            />

            <span>{p.name}</span>
          </div>
        ))}
      </>
    )}

    {imageResults.length > 0 && (
      <>
        <HeadingTitle
          text="Image Results"
          style={styles.dropdownHeading}
        />

        {imageResults.map((p) => (
          <div
            key={p.id}
            className={styles.dropdownItem}
            onMouseDown={() =>
              goProduct(p.slug)
            }
          >
            <Image
              src={getImageUrl(
                p.thumb_image
              )}
              alt={p.name}
              className={styles.itemThumbnail}
            />

            <span>{p.name}</span>
          </div>
        ))}
      </>
    )}
  </div>
)}
</div>
    </form>
  );
};
export default GlobalProductsSearch;